import React from "react";
import { makeStyles } from "@mui/styles";
import { Box, Typography } from "@mui/material";
import AlternateEmailIcon from "@mui/icons-material/AlternateEmail";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";

const useStyles = makeStyles({
  bodyText2: {
    "&.MuiTypography-root": {
      color: "#bfbfbf",
      fontFamily: "Rajdhani, sans-serif",
      fontWeight: "500",
      fontSize: "2.3rem",
      lineHeight: "3.5rem",
    },
  },
  bt2pd: {
    "&.MuiTypography-root": {
      color: "#FFFFFF",
      paddingLeft: "5rem",
      paddingRight: "4rem",
    },
  },
  or: {
    "&.MuiTypography-root": {
      color: "#5c5c5c",
      margin: "0 auto",
    },
  },
  contactGrid: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    "&.MuiGrid-root": {
      flexDirection: "column",
    },
  },
  icon: {
    "&.MuiSvgIcon-root": {
      marginRight: "2rem",
      fontSize: "3rem",
      color: "#703a3e",
      transition: "1s",
    },
    "&.MuiSvgIcon-root:hover": {
      color: "#08FDD8",
    },
  },
});

function ContactDetails(props) {
  const { contact } = props;

  const classes = useStyles();
  return (
    <>
      <Typography
        variant="body2"
        component="div"
        className={`${classes.bodyText2} ${classes.bt2pd}`}
      >
        {contact.contactText}
      </Typography>
      <Box component="div" display="flex" flexDirection="column">
        <Typography
          variant="body2"
          component="div"
          className={`${classes.bodyText2} ${classes.or}`}
        >
          or
        </Typography>
        <Box component="div" display="flex" mt={2}>
          <AlternateEmailIcon className={classes.icon} />{" "}
          <Typography
            variant="body2"
            component="div"
            className={classes.bodyText2}
          >
            {contact.email}
          </Typography>
        </Box>

        <Box component="div" display="flex" mt={2}>
          <WhatsAppIcon className={classes.icon} sx={{ marginRight: "1rem" }} />

          <Typography
            variant="body2"
            component="div"
            className={classes.bodyText2}
          >
            {contact.mobile}
          </Typography>
        </Box>
      </Box>
    </>
  );
}

export default ContactDetails;
